import React from 'react';
import FormItem from '@/components/ui/FormItem';
import Textarea from '@/components/ui/Textarea';

export function DescriptionFormItem(): JSX.Element {
	return (
		<FormItem label="Description" name="description">
			<Textarea placeholder="Description" rows={4} maxLength={500} showCount />
		</FormItem>
	);
}
